import React from "react";
import Skeleton from "@mui/material/Skeleton";
import * as Styles from "../../../../styles";

const SkeletonPreferencias: React.FC = () => {
  return (
    <>
      <Styles.RowGap>
        <Styles.Column>
          <Skeleton
            variant="rectangular"
            width={160}
            height={18}
            style={{ marginBottom: 8 }}
          />
          <Skeleton variant="rounded" width="100%" height={40} />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Skeleton
            variant="rectangular"
            width={160}
            height={18}
            style={{ marginBottom: 8 }}
          />
          <Skeleton variant="rounded" width="100%" height={40} />
        </Styles.Column>
        <Styles.Column>
          <Skeleton
            variant="rectangular"
            width={160}
            height={18}
            style={{ marginBottom: 8 }}
          />
          <Skeleton variant="rounded" width="100%" height={40} />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Skeleton
            variant="rectangular"
            width={160}
            height={18}
            style={{ marginBottom: 8 }}
          />
          <Skeleton variant="rounded" width="100%" height={40} />
        </Styles.Column>
        <Styles.Column>
          <Skeleton
            variant="rectangular"
            width={160}
            height={18}
            style={{ marginBottom: 8 }}
          />
          <Skeleton variant="rounded" width="100%" height={40} />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Skeleton
            variant="rectangular"
            width={160}
            height={18}
            style={{ marginBottom: 8 }}
          />
          <Skeleton variant="rounded" width="100%" height={40} />
        </Styles.Column>
        <Styles.Column>
          <Skeleton
            variant="rectangular"
            width={160}
            height={18}
            style={{ marginBottom: 8 }}
          />
          <Skeleton variant="rounded" width="100%" height={40} />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Skeleton
            variant="rectangular"
            width={160}
            height={18}
            style={{ marginBottom: 8 }}
          />
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Skeleton
              variant="rounded"
              width={30}
              height={30}
              style={{ borderRadius: 20, marginRight: 5 }}
            />
            <Skeleton
              variant="rounded"
              width={30}
              height={30}
              style={{ borderRadius: 20, marginRight: 5 }}
            />
            <Skeleton
              variant="rounded"
              width={30}
              height={30}
              style={{ borderRadius: 20, marginRight: 5 }}
            />
            <Skeleton
              variant="rounded"
              width={30}
              height={30}
              style={{ borderRadius: 20, marginRight: 5 }}
            />
          </div>
        </Styles.Column>
        <Styles.Column />
      </Styles.RowGap>
      <Styles.SpaceY space={22} />
      <Styles.RowGap>
        <Skeleton variant="rounded" width="100%" height={40} />
        <Skeleton variant="rounded" width="100%" height={40} />
      </Styles.RowGap>
    </>
  );
};

export default SkeletonPreferencias;
